import { Controller, useFormContext } from 'react-hook-form';

import { Checkbox } from '@mui/material';
import { FormControlLabelProps } from '@mui/material/FormControlLabel/FormControlLabel';
import { StyledFormControlLabel } from 'components/admin-portal/Tables/Settings/AdminFunctions/filter/FilterComponent.styles';

type Option<T> = {
  flag: T;
  label: string;
};

interface FlagCheckboxProps<T extends string>
  extends Omit<FormControlLabelProps, 'control'> {
  name: string;
  flags: Option<T>[];
}

export const ControlledFlagMultiCheckboxSingleSelect = <T extends string>({
  name,
  flags,
  label,
  ...formControlProps
}: FlagCheckboxProps<T>) => {
  const { control, watch, setValue } = useFormContext();
  const flagsItem: string[] = watch(name);

  const handleCheckboxChange = (checked: boolean, flag: T) => {
    let newFlags = flagsItem.filter(
      (item) => !flags.some((f) => f.flag === item)
    );
    if (checked) {
      setValue(name, [...newFlags, flag]);
    } else {
      setValue(name, newFlags);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          {label}
          {flags.map((flag) => (
            <StyledFormControlLabel
              sx={{
                marginLeft: 5
              }}
              label={flag.label}
              {...formControlProps}
              control={
                <Checkbox
                  {...field}
                  checked={flagsItem?.includes(flag.flag)}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, flag.flag)
                  }
                />
              }
            />
          ))}
        </>
      )}
    />
  );
};
